//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductVariantContext} from '../../../context/productVariant';
import {useProductContext} from '../../../context';
import {debounce} from '../../../../../utils/functions';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '96px',
  },
}));

export default function VariantSkuCell() {
  const classes = useStyles();

  const variant = useProductVariantContext();
  const [productVariants] = useProductContext(
    product => product.productVariantSetting?.variants
  );
  const variantRequest = useProductVariantRequestContext();

  if (!variant || !variantRequest) return null;

  const handleChange = debounce(sku => {
    if (!productVariants) return;
    variantRequest.setSku(variant.id, sku);
  }, 750);

  return (
    <TableCell component="th" scope="row">
      <CustomTextField
        name="sku"
        defaultValue={variant.sku}
        className={classes.textField}
        type="text"
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
